//import Libraries
import React, { Component } from 'react'
import {connect} from 'react-redux';

//import Components
import Layout from '../../hoc/Layout/Layout';
import Cart from '../Store/Cart/Cart'

import Loading from '../../components/Loading/Loading';

//import actions

//import Style classes
import './Cart.css';

class CartPage extends Component{
    constructor(props){
        super(props);
    }

    componentDidMount(){

    }

    render(){
        const renderLoading = <Loading text={"This is Store page"}/>;
        const renderNotLoading =
            <div className="StoreWrapper">
                <Cart />
            </div>

        const loading = false;

        return (
            <Layout relative={true} isStore={true}>
            {
                 loading ? renderLoading : renderNotLoading 
            }
            </Layout>
        )
    }
}

const mapStateToProps = (state) => {
    return{
        products : state.products,
        category : state.category,
        user : state.user,
        simpleStore : state.store.simpleStore
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return{

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CartPage);


// WEBPACK FOOTER //
// ./src/pages/Cart/Cart.js